import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xZXVibHQ2MCB7CiAgaGVpZ2h0OiAxMDB2aDsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xZXVibHQ2MSB7CiAgdGV4dC1kZWNvcmF0aW9uOiBub25lOwogIGJhY2tncm91bmQ6ICNGRjY1NTI7CiAgcGFkZGluZzogMS41cmVtIDJyZW07Cn0';
export var containerStyle = '_1eublt60';
export var blinqAppLink = '_1eublt61';